import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { TaskGtNetCalculationResponseInterface } from '../definitions/task-gtnet-calculation-response.interface';

@Injectable()
export class TaskGetGtNetCalculationService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public getGtNetCalculation(taskId: string): Observable<TaskGtNetCalculationResponseInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/gtnet-calculation`;

    return this.client.get<TaskGtNetCalculationResponseInterface>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}